<template>
  <div class="row">
    <div class="col-sm-12">
      <selector-component
        id="model_type"
        v-model="modelType"
        :options="modelOptions"
        :label="trans('core.type')"
        :errormessage="getErrorMessage('model_type')"
        :disabled="disabled"
      />
    </div>

    <div
      v-if="modelType === group"
      class="col-sm-12"
    >
      <multi-select-component
        id="group_multi_select"
        v-model="model"
        type="group"
        :include="{ 'withProgram' : true }"
        :label="trans('core.group')"
        :placeholder="trans('core.type_or_click') + ' ...'"
        :max-selected-options="1"
        :errormessage="getErrorMessage('model')"
        :disabled="disabled"
      />
    </div>

    <div
      v-if="modelType === subscribableGrouping"
      class="col-sm-12"
    >
      <multi-select-component
        id="subscribable_grouping_multi_select"
        v-model="model"
        :value="model"
        type="subscribable-grouping"
        :include="{ 'withProgram' : true }"
        :label="trans_choice('core.subscribable_groupings', 1)"
        :placeholder="trans('core.type_or_click') + ' ...'"
        :max-selected-options="1"
        :errormessage="getErrorMessage('model')"
        :disabled="disabled"
      />
    </div>
  </div>
</template>

<script>
import SelectorComponent from '@/employees/components/FormComponents/SelectorComponent'
import MultiSelectComponent from '@/employees/components/FormComponents/MultiSelectComponent'
import { CLASSIFICATION_CONFIG_GROUP, CLASSIFICATION_CONFIG_SUBSCRIBABLE_GROUPING } from '@/constants'

export default {
  name: 'ModelSelect',
  components: { MultiSelectComponent, SelectorComponent },
  props: {
    value: {
      required: true,
      type: Object,
    },
    errors: {
      required: false,
      default: () => {},
      type: Object,
    },
    disabled: {
      required: false,
      default: false,
      type: Boolean,
    },
  },

  data () {
    return {
      group: CLASSIFICATION_CONFIG_GROUP,
      subscribableGrouping: CLASSIFICATION_CONFIG_SUBSCRIBABLE_GROUPING,
    }
  },

  computed: {
    modelType: {
      get () {
        return this.value.modelType
      },
      set (value) {
        let oldModel = this.value.modelType

        this.emitInput('modelType', value)

        if (oldModel !== value) {
          this.$emit('removeSelectedModel')
        }
      },
    },

    model: {
      get () {
        return this.value.model
      },
      set (value) {
        this.emitInput('model', value)
      },
    },

    modelOptions () {
      const options = {}
      options[this.group] = Lang.get('core.group')
      options[this.subscribableGrouping] = Lang.choice('core.subscribable_groupings', 1)

      return options
    },
  },

  methods: {
    checkCanFinish (value) {
      if (value.modelType === null || value.model.length === 0) {
        this.$emit('canNotFinishStep')
      } else {
        this.$emit('canFinishStep')
      }
    },

    emitInput (key, value) {
      const newValue = { ...this.value, [key]: value }

      this.$emit('input', newValue)

      this.checkCanFinish(newValue)
    },

    getErrorMessage (field) {
      if (this.errors && Object.keys(this.errors).includes(field)) {
        return this.errors[field].join(' ')
      }
    },
  },
}
</script>
